import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-6 col-xs-12 segment-one">
              <h3>Short Bio</h3>
              <p>
                Just a nerdy girl who loves to code, create art, and eat awesome
                food! :)
              </p>
            </div>
            <div className="col-lg-6 col-sm-6 col-xs-12 segment-two">
              <h2>FOLLOW ME</h2>
              <p>Feel free to follow me on any of my socials</p>
              <div className="social-media-container">
                <a
                  href="https://www.facebook.com/creationsbyjenniferkramer"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    className="icon"
                    icon={faFacebookF}
                    size="2x"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/in/creationsbyjenniferkramer/"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    className="icon"
                    icon={faLinkedinIn}
                    size="2x"
                  />
                </a>
                <a
                  href="https://www.twitter.com/artbyjennkramer/"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    className="icon"
                    icon={faTwitter}
                    size="2x"
                  />
                </a>
                <a href="https://www.instagram.com/em0cand3h/" target="_blank">
                  <FontAwesomeIcon
                    className="icon"
                    icon={faInstagram}
                    size="2x"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className="footer-bottom-text">
        All Rights Reserved &copy; 2021 Creations by Jennifer Kramer
      </p>
    </div>
    // <div className="footer">
    //     <div className="container">
    //         <div className="row">
    //             <div className="col-lg-3 col-md-2 col-sm-6">
    //                 <div className="row">
    //                     <div className="col">
    //                         <a className="footer-nav">Home</a>
    //                         <br/>
    //                         <a className="footer-nav">About Me</a>
    //                         <br/>
    //                         <a className="footer-nav">Services</a>
    //                     </div>
    //                     <div className="col">
    //                         <a className="footer-nav">Resume</a>
    //                         <br/>
    //                         <a className="footer-nav">Portfolio</a>
    //                         <br/>
    //                         <a className="footer-nav">Contact Me</a>
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className="col-lg-5 col-md-5 col-sm-6 align-items-center">
    //                 <div className="d-flex justify-content-center">
    //                     <a href="https://www.facebook.com/creationsbyjenniferkramer" target="_blank">
    //                         <FacebookIcon className="mx-3" size={36}/>
    //                     </a>
    //                     <a href="https://www.linkedin.com/in/creationsbyjenniferkramer/" target="_blank">
    //                         <LinkedinIcon className="mx-3" size={36}/>
    //                     </a>
    //                     {/* <a href="" target="_blank">

    //                     </a>
    //                     <a href="" target="_blank">

    //                     </a> */}
    //                     <p className="pt-3 text-center">
    //                         Copyright &copy;&nbsp;
    //                         {new Date().getFullYear()}&nbsp;Creations by Jennifer Kramer | All Rights Reserved
    //                     </p>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // </div>
  );
};

export default Footer;
